import { Typography } from '../../../atoms/typography/typography';

type AddressProps = {
  address: string;
};

export function Address(props: AddressProps) {
  const { address } = props;
  return (
    <Typography
      variant="body-xs"
      weight="regular"
      className="text-grayscale600"
    >
      {address}
    </Typography>
  );
}
